export default function getFormatVersion(version: string): string {
  return version;
}
